export class EpsonVp21 {
    constructor(socket, log) {
        this.socket = socket;
        this.displayBlank = false;
        this.displayFreeze = false;
        this.input = '30'; // hdmi 1
        this.power = false;
        this.speakerVolume = 100;
        this.asyncHandlers = [
            {
                name: 'displayBlank',
                regExp: /MUTE\?|MUTE (ON|OFF)/i,
                callback: (match) => {
                    if (this.power) {
                        if (match[1]) {
                            this.displayBlank = match[1].toUpperCase() === 'ON';
                            this.socket.send('');
                        }
                        else {
                            this.socket.send(`MUTE=${this.displayBlank ? 'ON' : 'OFF'}\x0d`);
                        }
                    }
                    else {
                        this.socket.send('ERR\x0d');
                    }
                },
            },
            {
                name: 'displayFreeze',
                regExp: /FREEZE\?|FREEZE (ON|OFF)/i,
                callback: (match) => {
                    if (this.power) {
                        if (match[1]) {
                            this.displayFreeze = match[1].toUpperCase() === 'ON';
                            this.socket.send('');
                        }
                        else {
                            this.socket.send(`FREEZE=${this.displayFreeze ? 'ON' : 'OFF'}\x0d`);
                        }
                    }
                    else {
                        this.socket.send('ERR\x0d');
                    }
                },
            },
            {
                name: 'initialize',
                regExp: /ESC\/VP.net\x10\x03\x00\x00\x00\x00/i,
                callback: (match) => {
                    this.socket.send(`ESC/VP.net.\x03\x00\x00\x20\x00`);
                },
            },
            {
                name: 'input',
                regExp: /SOURCE\?|SOURCE (.+)/i,
                callback: (match) => {
                    if (this.power) {
                        if (match[1]) {
                            this.input = match[1];
                            this.socket.send('');
                        }
                        else {
                            this.socket.send(`SOURCE=${this.input}\x0d`);
                        }
                    }
                    else {
                        this.socket.send('ERR\x0d');
                    }
                },
            },
            {
                name: 'power',
                regExp: /PWR\?|PWR (ON|OFF)/i,
                callback: (match) => {
                    if (match[1]) {
                        this.power = match[1].toUpperCase() === 'ON';
                        this.socket.send('');
                    }
                    else {
                        this.socket.send(`PWR=${this.power ? '01' : '04'}\x0d`);
                    }
                },
            },
            {
                name: 'volume',
                regExp: /VOL\?|VOL (\d+)/i,
                callback: (match) => {
                    if (this.power) {
                        if (match[1]) {
                            this.speakerVolume = parseInt(match[1], 10);
                            this.socket.send('');
                        }
                        else {
                            this.socket.send(`VOL=${this.speakerVolume.toString(10)}\x0d`);
                        }
                    }
                    else {
                        this.socket.send('ERR\x0d');
                    }
                },
            },
        ];
        this.commandExtractor = {
            terminators: ['\r', '\n'],
        };
        this.sendTerminator = ':';
    }
    onConfigure(config) {
        var _a;
        let lowestCode;
        for (const videoInput of Object.values((_a = config.videoInputs) !== null && _a !== void 0 ? _a : {})) {
            const code = videoInput.code;
            if (this.input === code)
                return;
            if (lowestCode === undefined || parseInt(code, 10) < parseInt(lowestCode, 10)) {
                lowestCode = code;
            }
        }
        this.input = lowestCode !== null && lowestCode !== void 0 ? lowestCode : '6';
    }
}
EpsonVp21.emulatorType = 'socketEmulator';
EpsonVp21.key = '-KhyiWQkKIUKd8lDV9Ij';
